import React, { useContext, useState } from 'react'
import './SignUp.css'
import { assets } from '../assets/assets'
import { StoreContext } from '../context/StoreContext'
import axios from "axios"

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export default function SignUp({setShowLogin}) {

    const {url,setToken} = useContext(StoreContext)
    const {user,setUser} = useContext(StoreContext)
    

    const [ currState,setCurrState] = useState ("Login")
    const [data,setData] = useState({
        name:"",
        email:"",
        password:""
    })

    const onChangeHandler = (event) => {
        const name = event.target.name;
        const value = event.target.value;
        setData(data=>({...data,[name]:value}))
    }

    const onLogin = async (event) => {
        event.preventDefault();
        let newUrl = url;
        let action = "";

        if (currState === "Login") {
            newUrl += "/api/user/login";
            action = "Login";
        } else {
            newUrl += "/api/user/register";
            action = "Registration";
        }

        try {
            const response = await axios.post(newUrl, data);
            if (response.data.success) {
                setToken(response.data.token);
                localStorage.setItem("token", response.data.token);
                
                setUser(response.data.user);
                localStorage.setItem("user", JSON.stringify(response.data.user));

                toast.success(`${action} Successful!`, { toastId: "login-success" });
                setTimeout(() => {
                    setShowLogin(false);
                }, 1800);
            } else {
                toast.error(response.data.message || `${action} Failed.`);
            }
        } catch (error) {
            console.error("Error:", error);
            toast.error(`Something went wrong. Please try again later.`);
        }
    }


  return (
    <>
    <div className="login-popup">
    <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        pauseOnHover
        draggable
    />
        <form onSubmit={onLogin} className="login-popup-container">
            <div className="login-popup-title">
                <h2>{currState}</h2>
                <img onClick={()=>setShowLogin(false)} src={assets.cross_icon} alt="" />
            </div>
            <div className="login-popup-inputs">
                {currState==="Login"?<></>:<input name='name' onChange={onChangeHandler} value={data.name} type="text" placeholder='Enter Username' required />}
                <input name='email' onChange={onChangeHandler} value={data.email} type="email" placeholder='Enter Email' required />
                <input name='password' onChange={onChangeHandler} value={data.password} type="password" placeholder='Enter Password' required />
            </div>
            <button type='submit'>{currState==="Sign Up"?"Create Account":"Login"}</button>
            {currState==="Login"
            ?<p>Create a new account? <span onClick={()=>setCurrState("Sign Up")}>Click here</span></p>
            :<p>Already have an account? <span onClick={()=>setCurrState("Login")}>Login here</span></p>
            }
        </form>
    </div>
    </>
  )
}
